import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StateEnrollmentParams } from "../types/enrollment/enrollment";

interface EnrollmentUsersInitialStateParams {
    isLoading: boolean;
    getAllEnrollmentUsers: StateEnrollmentParams[];
    currentPage: number;
}

const initialState: EnrollmentUsersInitialStateParams = {
    isLoading: true,
    getAllEnrollmentUsers: [],
    currentPage: 1,
}

const enrollmentUsersSlice = createSlice({
    name: 'ENROLLMENT',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setEnrollmentUsers: (state, action: PayloadAction<{
            data: StateEnrollmentParams[];
            currentPage: number;
        }>) => {
            state.getAllEnrollmentUsers   = action.payload.data;
            state.currentPage         = action.payload.currentPage;
        },
    }
});

export const { startLoading, endLoading, setEnrollmentUsers } = enrollmentUsersSlice.actions
export default enrollmentUsersSlice.reducer
